export default "__VITE_ASSET__BrosEcCE__"